export default [{
  name: 'addTerminal',
  path: 'addTerminal',
  component: () => import('./AddTerminal.vue'),
  meta: {
    title: '终端保存'
  }
}]



// WEBPACK FOOTER //
// ./src/router/add_terminal/index.js